import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseService } from '../../shared/services/base.service';
import { UtilService } from '../../services/util.service';
import { AppService } from '../../shared/services/app.service';
import { PopupFormComponent } from '../popupform/popupform.component';
import { StorageService } from '../../shared/services/storage.service';
import { AlertsService } from '../../services/alerts.service';
import { LoaderService } from '../../services/loader.service';
import { PrintService } from '../../shared/services/print.service';
import { ActivatedRoute } from '@angular/router';
import { DialogService } from '../dialog/dialog.service';
import { DialogModalSize } from '../dialog/dialog-ref';
import { RolePermissionService } from '../../shared/services/role-permission.service';
import { DynamicPopUpComponent } from '../data-grid/dynamic-pop-up/dynamic-pop-up.component';

@Component({
    selector: 'dhs-pullable',
    templateUrl: './pullable.component.html',
    styleUrls: ['./pullable.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => PullableComponent),
            multi: true
        }
    ],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PullableComponent implements OnInit {
  @Input() label: any;
  @Input() question: any;
  @Input() current_action: string;
  @Input() id: any;
  @Input('value') _value = false;
  @Input() className;
  @Output() valueChange = new EventEmitter<any>();
  @Input() options: any;
  @Input() type: any;
  @Input() disabled_: boolean = false;
  @Input() bannerJson: any;
  propagateChange = (_: any) => { };
  onTouched: any = () => { };
  checkboxData: Array<any> = [];
  dataGridConfig = {
    "viewAll": true,
    "hideSearchBox": true,
    "hideResult": false,
    "customButtonsAllowed": false,
    "allowPagination": false,
  };
  grid: boolean = false;
  page: any = 0;
  limit: any = 10;
  gridData: any = {};
  reportData: any = {};
  bannerData: any;
  popUpGridFields: any;
  selectedItemData: any;
  packageSummaryReportConfig: string = 'inhouse';
  showArtPatientOptions: boolean = false;
  artPatientOptions: any[] = [];
  addedFieldsForArtPatient = [{
      "heading": "field.label.art_no",
      "card_tag": null,
      "order": 1,
      "sortable": true,
      "name": "ivf_no"
    }, {
      "heading": "field.label.uhId",
      "card_tag": null,
      "order": 1,
      "sortable": true,
      "name": "uhId"
    }, {
      "heading": "field.label.art_role_name",
      "card_tag": null,
      "order": 1,
      "sortable": true,
      "name": "art_role_name"
    }]
  constructor(public dialogService: DialogService,
    public aRoute: ActivatedRoute,
    private baseService: BaseService,
    private utilService: UtilService,
    public appService: AppService,
    public storageService: StorageService,
    public alerts: AlertsService,
    public loader?: LoaderService,
    private printService?: PrintService,
    public rolePermissionService?: RolePermissionService,
  ) { }

  ngOnInit() {
    if (sessionStorage && sessionStorage.currentData)
      this.bannerData = JSON.parse(sessionStorage.currentData)
    this.question.value = this.parse(this.question.value)
    if(this.bannerData?.ivf_no){
      this.question.pullable_response_array =[...this.addedFieldsForArtPatient,...this.question.pullable_response_array]
    }
    if (this.question.pullableData.bannerJson != undefined)
      this.bannerJson = this.question.pullableData.bannerJson
    // make pullable response array
    let indexArr = []
    this.question.pullable_response_array.forEach((element, index) => {
      if (!element.filterOnly) {
        if (element['data_type'])
          this.question.pullable_response_array[index] = this.utilService.makeFormatBasedOnType(element['data_type'], element.key, element['display_name'], element['sequence'], element['format'])
        if (element.wrap_text)
          this.question.pullable_response_array[index]['wrap_text'] = element.wrap_text;
        if (element.editable)
          this.question.pullable_response_array[index]['editable'] = element.editable;
        if (element.editable_type)
          this.question.pullable_response_array[index]['editable_type'] = element.editable_type;
        if (this.question?.pullableData?.resource == "observation" && (element.key == 'value' || element.key == 'referenceRange.referenceRange')) {
          this.question.pullable_response_array[index]['commaDisable'] = true;//178012
          if (element.key == 'referenceRange.referenceRange')
            this.question.pullable_response_array[index]['format'] = "fn=function(item){return (item.referenceRange != undefined && item.referenceRange.referenceRange!=undefined && item.referenceRange.referenceRange!='') ? item.referenceRange.referenceRange:''}";//178011 (need to make it common)
        }
      }
      if (element.filterOnly) {
        indexArr.push(index)
      }
      if (this.question.pullableData.resource == 'medicationOrderDetails') {
        this.question.pullable_response_array = this.question.pullable_response_array.map((ele) => {
          if (ele.name == "frequency" || ele.name == "dosage_no") {
            return { ...ele, "commaDisable": true }
          }
          else {
            return ele
          }
        })
      }
    });
    //splice filteronly field
    if (indexArr && indexArr.length > 0) {
      indexArr.forEach((ind, i) => {
        if (i == 0)
          this.question.pullable_response_array.splice(ind, 1)
        else this.question.pullable_response_array.splice(ind - 1, 1)
      });
    }

    this.popUpGridFields = [...this.question.pullable_response_array];//set grid fields for popup because here action button not needed

    if (this.question?.pullable_response_array?.length > 0 && this.question?.pullableData?.resource == "observation" && this.question?.pullableData?.query_id == "GET_OBSERVATIONS_BY_UHID") {
      this.question.pullable_response_array.push({
        "heading": "Action",
        "order": this.question.pullable_response_array.length,
        "sortable": false,
        "class_name": "freeze",
        "name": "",
        "config": {
          "type": this.utilService.isMobile() ? "ellipse" : "button",
          "buttonMenu": [
            {
              "key": "id",
              "action": "modify",
              "icon": "fa fa-pencil",
              "label": ""
            }
          ]
        }
      })
    }
    if (this.question?.auto_pullable && this.question?.pullable_response_array?.length > 0) {
      if (this.question.pullable_response_array[this.question.pullable_response_array.length - 1]
        .config?.buttonMenu?.length > 0) {
        this.question.pullable_response_array[this.question.pullable_response_array.length - 1].config.buttonMenu.push({
          "key": "id",
          "action": "delete",
          "icon": "fa fa-trash",
          "label": ""
        });
      } else {
        this.question.pullable_response_array.push({
          "heading": "Action",
          "order": this.question.pullable_response_array.length,
          "sortable": false,
          "class_name": "freeze",
          "name": "",
          "config": {
            "type": this.utilService.isMobile() ? "ellipse" : "button",
            "buttonMenu": [
              {
                "key": "id",
                "action": "delete",
                "icon": "fa fa-trash",
                "label": ""
              }
            ]
          }
        })
      }
      this.grid = true;
      if (this.current_action == 'ADD')
        this.callApi();
    }

    if (this.baseService?.router?.routerState.snapshot.url.includes("view_fit_unfit_package_certificate")) {
      this.grid = true;
    }

    if (this.baseService.router && this.baseService.router.routerState.snapshot.url.includes("clm_package_summary")) {
      if (!this.question.key.includes("_clmReport") && !this.question.key.includes("_ehc_report")) {
        this.grid = true;
        this.callApi();
      } else if (this.question.key.includes("_ehc_report")) {
        this.clmPackageSummaryReportConfig();//config to check inhouse/outsourced report (need to ask with product)
        this.reportData['linkName'] = this.question.key.includes('_ehc_report') ? "View Current Report" : "";
        this.reportData['hideLink'] = false;
        this.getPackageDetail();
        //need to make it configurable
        if (this.question.pullableData && this.question.pullableData.is_report && this.question.pullableData.serviceType_code == "pathology") {
          this.reportData['cumulativeInfo'] = {}
          this.question['action'] = "print"
          this.question['file_data'] = {
            "name": "Coumlative Report",
            "template": "clmCumulative",
            "application": "diagnostic",
            "resource": "observation",
            "args": "uhId:!!!uhId!!!,orderId:!!!orderId!!!,serviceType_code:pathology",
            "file_type": "pdf"
          }
          // if (this.question.key.includes("_ehc_report") && this.bannerData.reappliable_limit != this.bannerData.reapply_left) {
          this.question['file_data']['cumulativeInfo'] = {
            "args": "uhId:!!!uhId!!!,orderId:!!!previous_report_orderId!!!,serviceType_code:pathology",
            "reportTemplateId": " item.resultType == 'template' ? `templateDiagnostic` : item.isMultiStage ? `antibiotic` : `diagnostic`"
          }
          // } else {
          //   this.question['file_data']['cumulativeInfo'] = {
          //     "args": "uhId:!!!uhId!!!,orderId:!!!orderId!!!,serviceType_code:pathology",
          //     "reportTemplateId": " item.resultType == 'template' ? `templateDiagnostic` : item.isMultiStage ? `antibiotic` : `diagnostic`"
          //   }
          // }
          this.reportData['cumulativeInfo'] = this.question.file_data.cumulativeInfo
          this.applyPackageSummaryReportConfig();
        }
      } else if (this.question.key.includes("_clmReport")) {
        this.clmPackageSummaryReportConfig();//config to check inhouse/outsourced report
        this.reportData['linkName'] = this.question.key.includes('_current_clmReport') ? "View Current Report" : this.question.key.includes('_pre_clmReport') ? "View Previous Report" : "View Report";

        this.reportData['hideLink'] = false;
        if (this.question.key.includes("_pre_clmReport") && this.bannerData && this.bannerData.reappliable_limit == this.bannerData.reapply_left) {
          this.reportData['hideLink'] = true;
        }
        this.getPackageDetail();
        //need to make it configurable
        if (this.question.pullableData && this.question.pullableData.is_report && this.question.pullableData.serviceType_code == "pathology") {
          this.reportData['cumulativeInfo'] = {}
          this.question['action'] = "print"
          this.question['file_data'] = {
            "name": "Coumlative Report",
            "template": "clmCumulative",
            "application": "diagnostic",
            "resource": "observation",
            "args": "uhId:!!!uhId!!!,orderId:!!!orderId!!!,serviceType_code:pathology",
            "file_type": "pdf"
          }
          if (this.question.key.includes("_pre_clmReport") && this.bannerData && this.bannerData.reappliable_limit != this.bannerData.reapply_left) {
            this.question['file_data']['cumulativeInfo'] = {
              "args": "uhId:!!!uhId!!!,orderId:!!!previous_report_orderId!!!,serviceType_code:pathology",
              "reportTemplateId": " item.resultType == 'template' ? `templateDiagnostic` : item.isMultiStage ? `antibiotic` : `diagnostic`"
            }
          } else {
            this.question['file_data']['cumulativeInfo'] = {
              "args": "uhId:!!!uhId!!!,orderId:!!!orderId!!!,serviceType_code:pathology",
              "reportTemplateId": " item.resultType == 'template' ? `templateDiagnostic` : item.isMultiStage ? `antibiotic` : `diagnostic`"
            }
          }
          this.reportData['cumulativeInfo'] = this.question.file_data.cumulativeInfo
          this.applyPackageSummaryReportConfig();
        }
        // else if (this.question.pullableData && this.question.pullableData.is_report && this.question.pullableData.serviceType_code == "radiology") {
        //   this.question['action'] = "view_file"
        //   this.question['printKey'] = "id"
        //   this.question['file_data'] = {
        //     "template": "ris",
        //     "resource": "radio_provisioning_finalization",
        //     "args": "uhId:!!!uhId!!!,serviceRequestId:!!!serviceRequestId!!!,reportAction:view",
        //     "file_type": "pdf",
        //     "newPrint": true
        //   }
        // }
      }
    }
  }

  clmPackageSummaryReportConfig() {
    this.baseService.get('GET_CONFIG', "config_code:op_package_summary_report,module_code:order", 'facility_config_mapping', 'facility-management').subscribe(data => {
      let configValue = data?.resource?.[0]?.config_value;
      if (configValue == 'inhouse' || configValue == 'outsourced') {
        this.packageSummaryReportConfig = configValue;
        this.applyPackageSummaryReportConfig();
      }
    })
  }

  gridButtonClick(event) {
    console.log("event trigger=>", event);
    if (event && event.actionType && event.actionType.action === 'modify') {
      var arr = this.question.pullable_response_array;
      var fields = [];
      for (let i = 0; i < arr.length; i++) {
        var fieldObj = {};
        if (arr[i].editable != undefined && arr[i].editable) {
          if (arr[i].editable_type != undefined && arr[i].editable_type == 'textarea' || arr[i].editable_type == 'textbox' || arr[i].editable_type == 'html-editor') {
            fieldObj["type"] = "String";
          } else if (arr[i].editable_type != undefined && arr[i].editable_type == 'numberbox') {
            fieldObj["type"] = "double";
          } else if (arr[i].editable_type != undefined && arr[i].editable_type == 'checkbox') {
            fieldObj["type"] = "boolean";
          }
          fieldObj["component"] = arr[i].editable_type;
          fieldObj['label'] = arr[i].heading;
          fieldObj["class_name"] = "kx-control col-12 col-sm-6 col-md-8 col-lg-8 col-xl-8 fix";
          fieldObj["order"] = i;
          fieldObj["name"] = arr[i].name;

          fields.push(fieldObj);
        }
      }
      var formBlock = {
        "title": this.question.label,
        "form": {
          "blocks": [
            {
              "name": this.question.label,
              "class_name": "null",
              "layout_type": "one-column",
              "order": 1,
              "fields": fields
            }
          ]
        }
      }
      var action = {};
      var val = event.data;
      action['append_required'] = false;
      action['sendData'] = true;
      action['form'] = formBlock.form;
      let obj: any = Object.assign({ action }, { val }, { title: this.question.label }, { size: DialogModalSize.Md });
      //this.smartModalService.open(DynamicPopUpComponent, obj, this.question.label, ModalSize.Md).subscribe(response => {
      if (fields?.length > 0) {
        this.dialogService.open(DynamicPopUpComponent, obj).afterClosed.subscribe(response => {
          if (response && response.result && Object.keys(response.result).length != 0) {
            console.log("updated data =>", response);
            let isUpdate: boolean = false;
            Object.keys(response.result).forEach(elem => {
              if (event.data[elem] != response.result[elem]) {
                isUpdate = true;
                event.data[elem] = response.result[elem];
              }
            })
            console.log("updated row data =>", event);
            if (isUpdate) {
              const updated = [...this.question.value]; // clone array
              updated[event.index] = { ...event.data }; // replace with new object

              this.question.value = updated;
              this.value = updated;
              this.valueChange.emit(updated);
            }
            else {
              this.alerts.error("No changes detected")
            }
            console.log("final updated grid =>", this.question.value);
          }
        }, err => { console.log("error"); });
      } else {
        this.alerts.error("Editable Fields not defined")
      }
    }
    else {
      this.question.value.forEach((element, i) => {
        if (JSON.stringify(element) == JSON.stringify(event.data)) {
          this.question.value.splice(i, 1)
          this.value = this.question.value;
          this.valueChange.emit(this.question.value);
        }
      });
    }
  }

  getPackageDetail() {
    let data = {
      "args": "package_serviceRequestId:" + this.aRoute.snapshot.queryParams['key']
    }
    this.baseService.getData(data, '', "package_items_details", "order", "GET_PACKAGE_ITEMS").subscribe(res => {
      if (res && res.resource != undefined && res.resource.length > 0) {
        this.reportData['packageData'] = res.resource;
        this.callApi();
      }
    },
      err => {
        console.error("Error in getting data ", err);
      })
  }

  cumulativePrint(action) {
    if (action.action != undefined && action.action == 'print') {
      //check for pending service
      this.reportData['pendingService'] = false;
      if (this.reportData['packageData'] && this.reportData['packageData'].length > 0)
        this.reportData['packageData'].every(elem => {
          if (elem.serviceType_code == 'pathology' && elem.status != "Completed" && elem.status != "Cancelled") {
            this.reportData['pendingService'] = true;
            return false;
          } else return true;
        })

      action['items'] = [];
      action['items'].push(this.reportData['cardData']);
      if (action.file_data != undefined && action.file_data.cumulativeInfo != undefined && action.items != undefined && action.items.length > 0) {
        if (typeof action.file_data.cumulativeInfo == 'string')
          action.file_data.cumulativeInfo = this.reportData['cumulativeInfo']
        //let cumulativeInfoObject = JSON.parse(JSON.stringify(action.file_data.cumulativeInfo));
        let cumulativeInfo = this.baseService.createCumilativeObj({ action: action, items: action.items });
        action.file_data.cumulativeInfo = btoa(JSON.stringify(cumulativeInfo));
        this.openreport(action, { data: {} });
      }
    }
  }

  applyPackageSummaryReportConfig() {
    if (!(this.question?.key?.includes("_clmReport") || this.question?.key?.includes("_ehc_report")) || !this.question?.pullableData?.is_report) {
      return;
    }

    if (this.packageSummaryReportConfig == 'outsourced') {
      this.question['action'] = "view_file";
      this.question['action_name'] = "definalize_result_view_file";
      // this.question['file_data'] = {
      //   "resource": "observation",
      //   "template": "outsource",
      //   "args": "uhId:!!!uhId!!!,serviceRequestId:!!!serviceRequestId!!!,reportAction:view,reportTemplateId:outsource",
      //   "query_id": "GET_UPLOADED_DOCUMENT",
      //   "file_type": "pdf"
      // }
    }
  }

  isOutsourcedPackageReport(action) {
    return (this.packageSummaryReportConfig == 'outsourced')
      && action?.action == 'view_file'
      && action?.action_name == 'definalize_result_view_file';
  }

  openOutsourcedPackageReport(action, data, callback = null) {
    // if (!data || !(data.profile_id || data.uploadedDocumentId || data.isOutsourced)) {
    //   this.alerts.error('Report is not exist');
    //   if (callback) {
    //     callback(false);
    //   }
    //   return;
    // }

    this.loader.showSpinner();
    let viewEnable = action.action_name == 'definalize_result_view_file' ? ",isView:true" : '';
    let datasource = {
      "application": "diagnostic",
      "query_id": "GET_DOCUMENTID_FROM_SPECIMEN",
      "resource": "specimen",
      "args": "uhId:" + data.uhId + ",orderId:" + data.orderId + ",serviceType_code:pathology"
    }
    this.baseService.get(datasource.query_id, datasource.args, datasource.resource, datasource.application).subscribe(res => {
      if (res.errCode != undefined && res.errCode == 0 && res.resource.length > 0) {
        this.bulkDownloadOutsourcedPackageReport(res.resource[0], action.action, datasource, callback);
      }
      else {
        console.log("No such record found " + res.message);
        this.alerts.error(res.message);
        if (callback) {
          callback(false);
        }
        this.loader.hideSpinner();
      }
    }, err => {
      console.error("Error in getting outsourced report ", err);
      this.alerts.error('API error');
      if (callback) {
        callback(false);
      }
      this.loader.hideSpinner();
    });
  }

  bulkDownloadOutsourcedPackageReport(obj, action, datasource, callback = null) {
    let key = obj.profile_id ? obj.profile_id : obj.uploadedDocumentId;
    let url = '/dms/api/v1/' + 'emrImage' + '/image-response-entity?path=' + key;
    this.baseService.getFileByUrl(url, false).subscribe(res => {
      if (res) {
        this.printService.handleFileReponse({
          contentTypeChange: true,
          contentType: res.type,
          key: obj.serviceItemName,
          s3: true
        }, action, res, callback);
      } else if (callback) {
        callback(false);
      }
      this.loader.hideSpinner();
    }, err => {
      console.error("Error in downloading outsourced report ", err);
      this.alerts.error('server error');
      if (callback) {
        callback(false);
      }
      this.loader.hideSpinner();
    });
  }

  openreport(action, obj, callback = null) {
    if ((obj && obj.data && Object.keys(obj.data).length > 0) || (action.action == 'print' && !this.reportData['pendingService']) || this.isOutsourcedPackageReport(action)) {
      this.loader.stophideSpinner(true);
      this.reportData['reportExist'] = false;
      let val 
      if(action.key.includes('_ehc_report')){
         val = '_ehc_report'
      }else{
         val = action.key.includes('_current_clmReport') ? '_current_clmReport' : action.key.includes('_pre_clmReport') ? '_pre_clmReport' : '_clmReport';
      }
      
      this.reportData['packageData'].every(elem => {
        //add _pre_clmReport check in case in packageData service is not coming but pre-report is exist
        if ((elem.serviceItemCode + val == action.key && elem.status != "Cancelled") || action.key.includes('_pre_clmReport') || action.key.includes('_ehc_report')) {
          this.reportData['reportExist'] = true;
          // obj.data = Object.assign({}, elem, obj.data || {});
          // obj.data['serviceRequestId'] = obj.data['serviceRequestId'] ? obj.data['serviceRequestId'] : elem.serviceRequestId;//added for outsource report
          obj.data['uhId'] = elem.uhId;
          if (this.bannerData != undefined) {
            let previous_report_orderId = this.bannerData.last_report_orderId && this.bannerData.last_report_orderId != '' ? this.bannerData.last_report_orderId : this.bannerData.previous_report_orderId;
            obj.data['orderId'] = action.key.includes('_pre_clmReport') ? previous_report_orderId : this.bannerData.orderId;
          }
          if (this.isOutsourcedPackageReport(action)) {
            this.openOutsourcedPackageReport(action, obj.data, callback);
            return false;
          }
          if (action.file_data != undefined) {
            var printKey = (obj.data != undefined && obj.data[action.printKey] != undefined) ? obj.data[action.printKey] : action.file_data.name;
            this.loader.showSpinner();
            var fileObj = JSON.parse(JSON.stringify(action.file_data));
            fileObj.contentType = fileObj.file_type != undefined ? fileObj.file_type : 'pdf';
            fileObj.amount = fileObj.amount != undefined ? fileObj.amount : '';
            fileObj.resource = fileObj.resource != undefined ? this.baseService.buildDyanamicStr(fileObj.resource, obj) : '';
            fileObj.application = fileObj.application != undefined ? this.baseService.buildDyanamicStr(fileObj.application, obj) : this.appService.getApplication();
            fileObj.query_id = fileObj.query_id != undefined ? fileObj.query_id : undefined;
            fileObj.args = fileObj.args != undefined ? this.baseService.buildDyanamicStr(fileObj.args, obj) : false;
            fileObj.filter = fileObj.filter != undefined ? this.baseService.buildDyanamicStr(fileObj.filter, obj) : false;
            // if (this.appService.getOrganization() && fileObj.args != undefined && fileObj.args && this._currentData.bannerJson != undefined && this._currentData.bannerJson.key != undefined) {
            //   fileObj.args = fileObj.args + ",facility_id:" + (this.appService.getOrganization().org_id != "" ? this.appService.getOrganization().org_id : this._currentData.bannerJson.key.facility_id);
            // } else
            if (this.appService.getOrganization() && fileObj.args != undefined && fileObj.args && ((this.appService.getOrganization().org_id != undefined && this.appService.getOrganization().org_id) || (sessionStorage.getItem('facility_id') != undefined && sessionStorage.getItem('facility_id')))) {
              fileObj.args = fileObj.args + ",facility_id:" + (this.appService.getOrganization().org_id != "" ? this.appService.getOrganization().org_id : sessionStorage.getItem('facility_id'));
            }
            this.baseService.handleFile(fileObj, async (fileData) => {
              this.loader.stophideSpinner(false);
              if (fileData) {
                if (fileData.type == "application/json") {
                  try {
                    var response = await fileData.text();
                    response = JSON.parse(response);
                    if (response.errCode == -1 && response.message != undefined) {
                      this.alerts.error(response.message);
                    }
                    console.log(response);
                  } catch (e) {
                    this.alerts.error('API error');
                  }
                } else {
                  fileObj.key = printKey;
                  this.printService.handleFileReponse(fileObj, action.action, fileData, callback);
                }
              } else {
                this.alerts.error('server error');
                if (callback) {
                  callback(false);
                }

              }
              this.loader.hideSpinner();
            });
          } else {
            this.loader.stophideSpinner(false);
            console.error("Please provide File Data");
            if (callback) {
              callback(false);
            }
          }
          return false;
        } else return true;
      })
    } else
      this.alerts.error('Not able to view report due to pending service');

    if (!this.reportData['reportExist'])
      this.alerts.error('Report is not exist');
  }

  parse(val) {
    return typeof val == 'string' ? JSON.parse(val) : val
  }

  callApi() {
    this.storageService.getSessionStorageData('currentData', cardData => {
      cardData['previous_report_orderId'] = cardData['last_report_orderId'] && cardData['last_report_orderId'] != '' ? cardData['last_report_orderId'] : cardData['previous_report_orderId'];
      this.reportData['cardData'] = cardData;
      if (cardData)
        this.setArgsandFilter(this.question, cardData);
    })
    let datasource = {
      "args": this.gridData['args'] ? this.gridData['args'] : '',
      "filter": this.gridData['filter'] ? this.gridData['filter'] : '',
      page_size: this.limit,
      page_no: this.page
    }
    this.baseService.getData(datasource, '', this.question.pullableData.resource, this.question.pullableData.application_id, this.question.pullableData.query_id).subscribe(data => {
      this.reportData['data'] = {};
      if (data && data.resource != undefined && data.resource.length > 0) {
        if (this.question?.auto_pullable) {
          this.value = data.resource;
          this.valueChange.emit(data.resource);
        }
        else {
          this.reportData['data'] = data.resource[0]
          data.resource.forEach((elem, i) => {
            if (elem.service_item_code == this.question.key) {
              this.gridData[this.question.key] = {}
              var arr: any = [];
              this.gridData[this.question.key]['count'] = 0;
              arr.push(elem.template ? elem.template : elem);
              this.gridData[this.question.key]['resource'] = arr;
              if (this.gridData[this.question.key]['resource'].length > 0)
                this.gridData[this.question.key]['count'] = this.gridData[this.question.key]['count'] + 1;
            }
          })
        }
      }
    })
  }

  get value(): any {
    return this._value;
  }

  set value(val) {
    this._value = val;
    this.propagateChange(val);
    this.onTouched();
  }

  writeValue(value) {
    if (value) {
      this.value = value;
      if (typeof value == 'string') {
        if (this.question?.pullableData?.resource == 'patient_assigned_protocols') {
          try {
            this.selectedItemData = JSON.parse(value)[0]?.selectedItemData[0];
            this.question.value = JSON.parse(value)[0]?.selectedItemData;
          } catch (error) {
            this.selectedItemData = {};
            this.question.value = [];
          }
        } else {
          this.question.value = JSON.parse(value);
        }
      }
    } else {
      this.value = ""
    }
  }
  registerOnChange(fn: any) {
    this.propagateChange = fn;
  }
  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }
  isArtPatient(): boolean {
    return !!(this.bannerData?.ivf_no);
  }

  pullableButtonClick(question) {
    if (this.isArtPatient()) {
      this.toggleArtPatientOptions();
    } else {
      this.openPopup(question);
    }
  }

  toggleArtPatientOptions() {
    this.showArtPatientOptions = !this.showArtPatientOptions;
    if (this.showArtPatientOptions && this.artPatientOptions.length == 0) {
     this.loader.showSpinner();
      this.baseService.get('GET_PATIENT_BY_IVF_NO', 'ivf_no:' + this.bannerData.ivf_no, 'ivf_patient', 'patient-registration').subscribe(res => {
        if (res && res.resource != undefined && res.resource.length > 0) {
          this.artPatientOptions = res.resource;
        }
      this.loader.hideSpinner();
      });
    }
  }

  selectArtPatient(question, patient) {
    this.showArtPatientOptions = false;
    this.openPopup(question, patient.uhId, true, patient);
  }

  apiCallForArtPatient(question, artPatient, object, datasource, ivfPatientDetails) {
    this.baseService.get(datasource.query_id, datasource.args, datasource.resource, datasource.application, datasource.filter).subscribe(data => {
      if (data) {
        if(data?.resource?.length>0){
          delete object.preDefinedFields.list.APIresource
            object['preDefinedData'] = { resource: (data?.resource?.length > 0) ? data.resource : [] }
            object['preDefinedData']?.resource?.forEach(element => {
              element['art_role_name'] = ivfPatientDetails.art_role_name
              element['uhId'] = ivfPatientDetails.uhId
              element['ivf_no'] = ivfPatientDetails.ivf_no
            });
        }
        this.popUpPullableOpen(question, artPatient, object)
      }
    })
  }

  openPopup(question, overrideUhId?: string,artPatient?: boolean,ivfPatientDetails?) {
    this.storageService.getSessionStorageData('currentData', cardData => {
      if (cardData) {
        if (overrideUhId)
          cardData = { ...cardData, uhId: overrideUhId };
        this.setArgsandFilter(question, cardData);
        setTimeout(() => {
          let datasource = {
            "application": question?.pullableData?.application_id,
            "resource": question.pullableData.resource,
            "query_id": question.pullableData.query_id,
            "args": this.gridData['args'] ? this.gridData['args'] : '',
            "filter": this.gridData['filter'] ? this.gridData['filter'] : '',
          }
          if(question.pullableData.resource=='medicationOrderDetails')
            {
              this.popUpGridFields=this.popUpGridFields.map((ele)=>{if(ele.name=="frequency"||ele.name=="dosage_no"){
                return {...ele,"commaDisable":true}
              }
              else{
                return ele
              }
            })
            }
          let object = {
            data: {},
            application: question?.pullableData?.application?.toLowerCase(),
            type: 'pullable',
            action: "LIST",
            banner: this.bannerJson,
            fields: this.popUpGridFields,
            title: '',
            size: DialogModalSize.Xl,
            emitAll: question.pullableData.resource == 'patient_assigned_protocols' ? true : undefined,
            config: {
              "viewAll": true,
              "hideSearchBox": false,
              "hideResult": false,
              "allowPagination": true,
              "customButtonsAllowed": question.pullableData && question.pullableData.resource == "observation_vitals" ? false : true,
              "ehr_view": question.pullableData.ehr_view != undefined && this.rolePermissionService.checkAccessPermission('ehr_view', question.pullableData.resource, question.pullableData.application.toLowerCase()) ? question.pullableData.ehr_view : false,
              "ehr_view_default": question.pullableData.ehr_view_default == false ? false : true,
            },
            preDefinedFields: {
              list: {
                "APIresource": {
                  "datasource": datasource
                },
                "fields": this.popUpGridFields
              }
            }
          }
          if (question.filter && question.filter.includes('blocks') && JSON.parse(question.filter).blocks.length > 0 && JSON.parse(question.filter).blocks[0].fields.length > 0) {
            object.preDefinedFields.list['filter'] = JSON.parse(question.filter)
            if (object.preDefinedFields.list['filter'].decorator)
              object.preDefinedFields.list['filter']['default_filter'] = true;
          }
          if (question.complex_search && question.complex_search.length > 0) {
            object.config['complex_search'] = question.complex_search;
          }
          console.log(question, 'question.pullable_response_array');
          if(artPatient){
            this.apiCallForArtPatient(question,artPatient,object,datasource,ivfPatientDetails)
          } else {
            this.popUpPullableOpen(question,artPatient,object)
          }
        })
      } else
        this.alerts.error("Not getting Patient data")
    })
  }

  popUpPullableOpen(question,artPatient,object){
    if (question.pullable_response_array && question.pullable_response_array.length > 0) {
            this.dialogService.open(PopupFormComponent, object).afterClosed.subscribe(data => {
               if (data) {
                if(artPatient && question?.value?.length>0){
                  data = [...data,...question.value]
                }
                if (data?.length > 0 && data[0].protocol_type) {
                  this.selectedItemData = data[0];
                  this.value = data;
                  this.valueChange.emit(data);
                }
                else {
                  this.value = data;
                  this.valueChange.emit(data);
                }
              }
            }, err => { })
          } else
            this.alerts.error("Fields not defined")
  }

  setArgsandFilter(question, cardData) {
    if (question.pullableData.args) {
      if (question.key.includes("_clmReport")) {
        let val = question.key.includes('_current_clmReport') ? '_current_clmReport' : question.key.includes('_pre_clmReport') ? '_pre_clmReport' : '_clmReport';
        this.reportData['packageData'].every(elem => {
          if (elem.serviceItemCode + val == this.question.key) {
            elem['uhId'] = cardData.uhId
            elem['orderId'] = cardData.orderId
            this.makeArgsandFilter(question.pullableData, 'args', cb => {
              this.gridData['args'] = this.baseService.buildDyanamicStr(cb, { data: elem })
            })
            return false;
          } else return true;
        })
      }else if(question.key.includes('_ehc_report')){
        let val = '_ehc_report'
        this.reportData['packageData'].every(elem => {
          if ('pathology'+ val == this.question.key) {
            elem['uhId'] = cardData.uhId
            elem['orderId'] = cardData.orderId
            this.makeArgsandFilter(question.pullableData, 'args', cb => {
              this.gridData['args'] = this.baseService.buildDyanamicStr(cb, { data: elem })
            })
            return false;
          } else return true;
        })
      } else
        this.makeArgsandFilter(question.pullableData, 'args', cb => {
          this.gridData['args'] = this.baseService.buildDyanamicStr(cb, { data: cardData })
        })
    }
    if (question.pullableData.filter) {
      this.makeArgsandFilter(question.pullableData, 'filter', cb => {
        this.gridData['filter'] = this.baseService.buildDyanamicStr(cb, { data: cardData })
      })
    }
  }

  makeArgsandFilter(datasource, type, cb) {
    var search = '';
    if (datasource[type].indexOf(',') != -1) {
      var splittedArgs = datasource[type].split(",")
      splittedArgs.forEach(Key => {
        if (Key.indexOf(":") != -1) {
          var splittedKey = Key.split(":");
          search = search ? (search + "," + splittedKey[0] + ":!!!" + splittedKey[1] + "!!!") : (splittedKey[0] + ":!!!" + splittedKey[1] + "!!!");
        } else if (Key.indexOf("=") != -1) {
          var splittedKey = Key.split("=");
          search = search ? (search + "," + splittedKey[0] + ":" + splittedKey[1]) : (splittedKey[0] + ":" + splittedKey[1]);
        }
        else
          search = search ? (search + "," + Key + ":!!!" + Key + "!!!") : (Key + ":!!!" + Key + "!!!");
      });
    } else if (datasource[type].indexOf(':') != -1) {
      var splittedKey = datasource[type].split(":");
      search = search + splittedKey[0] + ":!!!" + splittedKey[1] + "!!!"
    } else if (datasource[type].indexOf("=") != -1) {
      var splittedKey = datasource[type].split("=");
      search = search ? (search + "," + splittedKey[0] + ":" + splittedKey[1]) : (splittedKey[0] + ":" + splittedKey[1]);
    }
    else {
      search = search + datasource[type] + ":!!!" + datasource[type] + "!!!"
    }
    cb(search);
  }
}